import type { CSSProperties, ReactNode } from 'react';

export interface BarSegment {
  /** Percent of the track. */
  width: number;
  colour?: string;
  className?: string;
  title?: string;
}

interface BarRowProps {
  label: ReactNode;
  segments: BarSegment[];
  value: ReactNode;
  wideValue?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

/** Prototype `.bar-row`: a label, a track with one or more fills, and the number. */
export function BarRow({ label, segments, value, wideValue, disabled, onClick }: BarRowProps) {
  return (
    <button type="button" className="bar-row" disabled={disabled} onClick={onClick}>
      <span className="bl">{label}</span>
      <span className="bar-track">
        {segments.map((s, i) => {
          const style: CSSProperties = { width: `${String(s.width)}%` };
          if (s.colour) style.background = s.colour;
          return (
            <span
              key={i}
              className={`bar-fill${s.className ? ` ${s.className}` : ''}`}
              title={s.title}
              style={style}
            />
          );
        })}
      </span>
      <span className={`bn${wideValue ? ' wide' : ''}`}>{value}</span>
    </button>
  );
}
